import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';

function LoadingDots() {
  return (
    <span className="login-dots">
      <span /><span /><span />
    </span>
  );
}

function GoogleIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" style={{ flexShrink: 0 }}>
      <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
      <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
      <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z"/>
      <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
    </svg>
  );
}

function UserIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="8" r="4" fill="#D1D5DB"/>
      <path d="M4 20c0-3.3 3.6-6 8-6s8 2.7 8 6" fill="#D1D5DB"/>
    </svg>
  );
}

export default function LoginPage() {
  const { signInWithGoogle, signInWithEmail, authError, clearAuthError, loading } = useAuth();
  const [email,         setEmail]         = useState('');
  const [password,      setPassword]      = useState('');
  const [emailLoading,  setEmailLoading]  = useState(false);

  useEffect(() => {
    clearAuthError();
    /* eslint-disable-next-line */
  }, []);

  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    setEmailLoading(true);
    await signInWithEmail(email, password);
    setEmailLoading(false);
  };

  return (
    <div className="login-page">

      <div className="login-logo-wrap">
        <img src="/eureka-logo.png" alt="Eureka AI" className="login-logo-img" />
      </div>

      <div className="login-card">
        <div className="login-header">
          <div className="login-title">Sign in</div>
          <div className="login-subtitle">Access the Omni Growth Platform</div>
        </div>

        {authError && (
          <div className="login-error">{authError}</div>
        )}

        {/* Client Access — Email/Password */}
        <div className="login-section-label">Client Access</div>

        <form onSubmit={handleEmailSubmit}>
          <div className="login-form-field">
            <input
              type="email"
              placeholder="Email address"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              autoComplete="email"
              disabled={emailLoading}
            />
          </div>
          <div className="login-form-field">
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              autoComplete="current-password"
              disabled={emailLoading}
            />
          </div>
          <button
            type="submit"
            className="login-primary-btn"
            disabled={emailLoading || loading}
          >
            {emailLoading ? <span>Signing in<LoadingDots /></span> : 'Sign in'}
          </button>
        </form>

        {/* Eureka AI Team — Google */}
        <div className="login-section-label" style={{ marginTop: 24 }}>Eureka AI Team</div>

        <button
          className="btn-google"
          onClick={signInWithGoogle}
          disabled={loading || emailLoading}
        >
          <div className="g-avatar"><UserIcon /></div>
          <div className="g-label">
            {loading ? <span>Signing in<LoadingDots /></span> : 'Continue with Google'}
          </div>
          <GoogleIcon />
        </button>

        <div className="g-hint">For @eureka.ai accounts only</div>

        <div className="login-restricted">Restricted to authorised users only</div>
      </div>

      <div className="login-footer">
        © 2026 Eureka AI · Actionable Intelligence at Scale
      </div>
    </div>
  );
}
